<template>
  <div class="innerItem">
    <p class="innerTitle setLabel">{{locale.setting_dateformat_default}}</p>
    <select v-model="date.default" class="input">
      <option v-for="item in date.list" :key="item.id" :value="item.id">{{item.format}}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SetDate',
  props: [
    'locale',
    'date'
  ]
}
</script>
